import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

const openById = new Map()

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    reactor(this)
    this.outsideClick = this.outsideClick.bind(this)
    document.addEventListener("click", this.outsideClick, true)
    this.open = openById.get(this.element.id) ?? false
    this.render()
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClick, true)
  }

  toggle() {
    this.open = !this.open
    openById.set(this.element.id, this.open)
    this.render()
  }

  close() {
    if (!this.open) return
    this.open = false
    openById.set(this.element.id, false)
    this.render()
  }

  outsideClick(event) {
    if (!this.open) return
    if (this.element.contains(event.target)) return
    this.close()
  }

  morph() {
    this.render()
  }

  render() {
    this.element.classList.toggle("is-open", this.open)
    if (!this.hasToggleTarget) return
    this.toggleTarget.setAttribute("aria-expanded", String(this.open))
  }
}
